var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "content-class": "aawz-markdown-field__dialog",
        "max-width": _vm.dialogMaxWidth,
        "retain-focus": false,
        persistent: "",
        scrollable: ""
      },
      on: { input: _vm.handleInput }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "aawz-markdown-field__dialog-card",
          class: { "is-preview-open": _vm.isPreviewOpen }
        },
        [
          _c("div", { staticClass: "aawz-markdown-field__dialog-body" }, [
            _c(
              "div",
              {
                staticClass: "aawz-markdown-field aawz-markdown-field--dialog",
                class: { "is-preview-only": _vm.previewOnly }
              },
              [
                _c(
                  "div",
                  { staticClass: "aawz-markdown-field__toolbar" },
                  [
                    !_vm.previewOnly
                      ? _c("MarkdownFieldWidgets", {
                          attrs: {
                            "can-edit": _vm.canEdit,
                            "table-picker": _vm.tablePicker,
                            "table-picker-label": _vm.tablePickerLabel,
                            "menu-value": _vm.tablePicker.openExpanded,
                            "menu-attach": "#" + _vm.dialogId
                          },
                          on: {
                            "toolbar-action": _vm.handleToolbarAction,
                            "table-open": _vm.handleTableOpenExpanded,
                            "table-hover": _vm.handleTableHover,
                            "table-clear": _vm.handleTableClear,
                            "table-apply": _vm.handleTableApply
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "az-text-primary az-size-12 font-medium flex-grow-1 px-1"
                          },
                          [_vm._v(" Pré-visualização ")]
                        ),
                    _c(
                      "div",
                      { staticClass: "aawz-markdown-field__toolbar-actions" },
                      [
                        !_vm.previewOnly
                          ? _c(
                              "v-btn",
                              {
                                staticClass:
                                  "aawz-markdown-field__toolbar-toggle",
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  title: _vm.isPreviewOpen
                                    ? "Ocultar preview"
                                    : "Mostrar preview"
                                },
                                on: {
                                  mousedown: function($event) {
                                    $event.preventDefault()
                                  },
                                  click: _vm.togglePreview
                                }
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isPreviewOpen
                                          ? "mdi-chevron-left"
                                          : "mdi-chevron-right"
                                      ) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "aawz-markdown-field__toolbar-toggle",
                            attrs: { icon: "", "x-small": "", title: "Fechar" },
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault()
                              },
                              click: _vm.handleClose
                            }
                          },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: "close",
                                size: "12",
                                color: "#8E8E8E"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "aawz-markdown-field__dialog-content",
                    class: {
                      "is-preview-open": _vm.isPreviewOpen,
                      "is-preview-only": _vm.previewOnly
                    }
                  },
                  [
                    !_vm.previewOnly
                      ? _c(
                          "div",
                          _vm._b(
                            {
                              ref: "expandedEditor",
                              staticClass:
                                "aawz-markdown-field__editor aawz-markdown-field__editor--expanded new-ux-scroll",
                              class: {
                                "has-placeholder": _vm.isEmpty,
                                "is-markdown": true
                              },
                              attrs: {
                                contenteditable: _vm.canEdit,
                                "data-placeholder": _vm.placeholder,
                                "aria-disabled": !_vm.canEdit
                              },
                              on: {
                                input: _vm.handleEditorInput,
                                focus: _vm.handleEditorFocus,
                                blur: _vm.handleEditorBlur,
                                keydown: _vm.handleEditorKeydown,
                                mouseup: _vm.handleEditorMouseup,
                                keyup: _vm.handleEditorKeyup,
                                paste: _vm.handleEditorPaste
                              }
                            },
                            "div",
                            _vm.$attrs,
                            false
                          )
                        )
                      : _vm._e(),
                    _vm.isPreviewOpen || _vm.previewOnly
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "aawz-markdown-field__preview markdown-style new-ux-scroll"
                          },
                          [
                            _c("AawzMarkdownRender", {
                              attrs: { source: _vm.previewValue || "" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                !_vm.previewOnly
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "aawz-markdown-field__dialog-send",
                        attrs: {
                          small: "",
                          icon: "",
                          primary: "",
                          title: "Enviar",
                          disabled: !_vm.canEdit
                        },
                        on: {
                          mousedown: function($event) {
                            $event.preventDefault()
                          },
                          click: _vm.handleSend
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            size: "30",
                            name: "route-square",
                            color: "primary"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }